import { Button, type ButtonProps } from '@numa-group/ui.button';

type ModalFooterActionProps = ButtonProps;

export const ModalFooterAction = ({ children, ...props }: ModalFooterActionProps) => (
  <Button {...props}>{children}</Button>
);
